import { Link } from "react-router-dom";
import type { LineageNode } from "@shared/types";
import { StatusPill } from "./Status";

export function LineageGraph({ nodes }: { nodes: LineageNode[] }) {
  const ordered = [...nodes].sort((a, b) => (a.year ?? 0) - (b.year ?? 0));
  const w = Math.max(720, ordered.length * 140);
  const h = 180;
  return (
    <div className="lineage">
      <svg viewBox={`0 0 ${w} ${h}`} width="100%" role="img" aria-label="Model lineage">
        <line x1="24" y1="90" x2={w - 24} y2="90" stroke="rgba(245,245,242,0.16)" strokeWidth="1" />
        {ordered.map((n, i) => {
          const x = 48 + i * ((w - 96) / Math.max(ordered.length - 1, 1));
          const y = n.kind === "event" ? 46 : n.kind === "decision" ? 134 : 90;
          return (
            <g key={n.id}>
              {i > 0 && (
                <line
                  x1={48 + (i - 1) * ((w - 96) / Math.max(ordered.length - 1, 1))}
                  y1={ordered[i - 1].kind === "event" ? 46 : ordered[i - 1].kind === "decision" ? 134 : 90}
                  x2={x}
                  y2={y}
                  stroke="#2aa6a6"
                  strokeWidth="1.2"
                  opacity="0.65"
                />
              )}
              <circle cx={x} cy={y} r="6" fill={n.synthetic ? "#c77a2e" : "#2aa6a6"} />
              <text x={x} y={y - 14} textAnchor="middle" fill="#7ec8c8" fontSize="10" fontFamily="IBM Plex Mono, monospace">
                {n.year ?? "—"}
              </text>
            </g>
          );
        })}
      </svg>
      <ol className="lineage-list">
        {ordered.map((n) => (
          <li key={n.id}>
            <Link to={n.href}>
              <span className="font-data">{n.year ?? "—"}</span>
              <strong>{n.title}</strong>
              <span className="muted small">
                {n.kind} · {n.rel}
              </span>
              {n.synthetic ? <StatusPill status="DEMO / SYNTHETIC" /> : null}
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}
